import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NumberOnlyDirective } from '@app/core/directives/number-only-directive';
import { TRemoveConfirmationType } from '@campaign-form/form-fields/creators-and-ctas/cta-details.interface';
import { CustomCtaBaseDirective, ECustomFieldType } from '@core/directives/custom-cta-base.directive';
import { TFieldChangeTrackingContext } from '@core/services/custom-values.service';
import { TExpectedKpi } from '@interfaces/campaign-analytics.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';

@Component({
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    NumberOnlyDirective,
    MatErrorComponent,
    MatCheckboxModule,
    MatExpansionModule,
    IconComponent,
  ],
  selector: 'app-expected-kpi',
  templateUrl: './expected-kpi.component.html',
})
export class ExpectedKpiComponent extends CustomCtaBaseDirective {
  protected override readonly removeConfirmationType: TRemoveConfirmationType = 'expectedKpi';

  public dummyTitleControl = new FormControl<string>('');

  protected readonly customValueConfig = {
    componentFields: {
      getForm: (): FormGroup => this.form(),
      managedFields: [
        { name: 'id', type: ECustomFieldType.string },
        { name: 'expectedValue', type: ECustomFieldType.number },
      ],
    },
  };

  // KPIs are their own tracking kind (Wave 9) - executionId/kpi come from this row's own form, not
  // the parent execution's id/type (see custom-values.service.ts's IKpiFieldChangeTrackingContext).
  protected override get trackingContext(): TFieldChangeTrackingContext {
    return {
      getCtaTemplateId: (): string | undefined => this.ctaTemplateId(),
      getExecutionId: (): string | undefined => this.form().get('executionId')?.value ?? undefined,
      getExpectedKpiId: (): string | undefined => this.form().get('id')?.value ?? undefined,
      getKpi: (): TExpectedKpi | null => this.form().get('kpi')?.value ?? null,
      kind: 'kpi',
    };
  }
}
